import { render, staticRenderFns } from "./DataControlDashboard.vue?vue&type=template&id=b45459fe&scoped=true"
import script from "./DataControlDashboard.vue?vue&type=script&lang=js"
export * from "./DataControlDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45459fe",
  null
  
)

export default component.exports